import React from "react";

import { useNotification } from "@refinedev/core";
import { CopyIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export interface CopyButtonProps {
  text: string;
  message: string;
  /**
   * Merged onto the default `p-1`, so a dense context (a table cell) can shrink the
   * button — e.g. `"h-6 w-6 p-0"` — without every existing call site having to opt in.
   */
  className?: string;
}

export const CopyButton = ({ text, message, className }: CopyButtonProps) => {
  const { open } = useNotification();

  return (
    <Button
      variant={"ghost"}
      className={cn("p-1", className)}
      onClick={() => {
        navigator.clipboard.writeText(text);
        open?.({
          message,
          type: "success",
        });
      }}
    >
      <CopyIcon size={16} />
    </Button>
  );
};
